module.exports = __webpack_public_path__ + "static/car-loan-f1ec26790a4cfbee18d8cc18b8673f72.jpg";